import React, { useEffect } from 'react'
import { Form } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux';
import { appLoadDataAsyncThunk, ClaimLemlAsyncThunk } from '../../redux/pagesSlices/emolume_bank';
import CustomButton from '../customs/CustomButton';

export default function ClaimLeml({ networkID, provider, address }) {

    const { analytics } = useSelector(state => state.bank);
    const { claimableLDBN } = analytics;
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(appLoadDataAsyncThunk({ networkID, provider, address }))
        return () => {
        }
    }, [])


    return (
        <div className='method-component'>
            <h2>Claim your LDBN</h2>
            <p>You have {claimableLDBN} LDBN for claim, click to claim.</p>
            <Form noValidate>
                <div className='contact-form'>
                    <div className='contact-us '>
                        <div className='inner-row'>
                            <CustomButton
                                title={'Claim LDBN'}
                                type="submit"
                                slice={'bank'}
                                action={"ClaimLemlAsyncThunk"}
                                variant="warning"
                                btnClass="buy-btn w-100"
                                onClick={(e) =>{
                                    e.preventDefault();
                                    dispatch(ClaimLemlAsyncThunk({ networkID, provider }))
                                }
                            }
                            />
                        </div>

                    </div>
                </div>
            </Form>
        </div>
    )
}
